<template>
	<div class="page-users page-content" v-loading="body_loading">
		<div class="main-body">
			<el-row class="hd">
				<el-col :span="24">
					<h3 style="float: none;">用户列表</h3>
					<div class="flex-block breadcrumb-box">
						<div class="position-text">位置：</div>
						<el-breadcrumb separator-class="el-icon-arrow-right">
							<el-breadcrumb-item>用户管理</el-breadcrumb-item>
							<el-breadcrumb-item>用户列表</el-breadcrumb-item>
						</el-breadcrumb>
					</div>
				</el-col>
			</el-row>
			<div class="bd">
				<div class="search-block content-body">
					<el-form :inline="true" ref="formSearch" :model="form_search" class="demo-form-inline"
						@submit.native.prevent>
						<el-form-item prop="number" label="用户编号：">
							<el-input v-model="form_search.number" type='text' size="small" placeholder="请输入用户编号"
								clearable></el-input>
						</el-form-item>
						<el-form-item prop="name" label="用户昵称：" style="margin-bottom: 0;">
							<el-input v-model="form_search.name" size="small" placeholder="用户昵称" clearable></el-input>
						</el-form-item>
						<el-form-item prop="status" label="状态：">
							<el-select size="small" v-model="form_search.status" placeholder="请选择" style="width:100%;">
								<el-option v-for="item in init_data.status_list" :key="item.id" :label="item.name"
									:value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item style="margin-bottom: 0;">
							<el-button type="primary" class="search-btn" size="medium" @click='searchList()'>查询
							</el-button>
						</el-form-item>
					</el-form>
				</div>
				<div class="table-block content-body">
					<div ref="contentBody">
						<el-table ref="multipleTable" :data="table_data.list" v-loading="table_data.loading"
							tooltip-effect="dark" style="width: 100%;text-align: center;">
							<el-table-column prop="id" align="center" label="ID" min-width="90">
							</el-table-column>
							<el-table-column prop="number" align="center" label="用户编号" min-width="160">
							</el-table-column>
							<el-table-column prop="nick_name" align="center" label="用户昵称" min-width="120">
								<template slot-scope="scope">
									<span v-if="scope.row.custom_nick_name">{{scope.row.custom_nick_name}}</span>
									<span v-else>{{scope.row.nick_name}}</span>
								</template>
							</el-table-column>
							<el-table-column prop="avatar_url" align="center" label="用户头像" min-width="80">
								<template slot-scope="scope">
									<img class="cursor" :src="scope.row.avatar_url" height="23"
										@click="dlg_preview.img_url = scope.row.avatar_url;dlg_preview.visible = true;"
										title="点击查看" />
								</template>
							</el-table-column>
							<el-table-column prop="birthday" align="center" label="生日" min-width="120">
							</el-table-column>
							<el-table-column prop="profession" align="center" label="职业" min-width="120">
							</el-table-column>
							<el-table-column prop="c_time" align="center" label="注册时间" min-width="160">
							</el-table-column>
							<el-table-column prop="last_login_date" align="center" label="最后登录时间" min-width="160">
							</el-table-column>

							<el-table-column prop="status_name" align="center" label="状态" min-width="120">
								<template slot-scope="scope">
									<span :class="'status-'+scope.row.status">{{scope.row.status_name}}</span>
								</template>
							</el-table-column>

						</el-table>
					</div>
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:current-page="table_data.page_info.page" :page-sizes="[10,30, 50,80,100]"
						:page-size="table_data.page_info.pageSize" layout="total, sizes, prev, pager, next"
						:total="table_data.page_info.total">
					</el-pagination>
				</div>
			</div>
			
			<el-dialog :visible.sync="dlg_preview.visible" class="dialog-no-title text-center" width="420px">
				<img width="100%" :src="dlg_preview.img_url" style="max-width:100%;">
			</el-dialog>
		</div>
	</div>
</template>
<script>
	export default {
		name: 'usercenter',
		data() {
			return {
				clientHeight: '',
				body_loading: false,
				is_refresh: true,
				form_search: {
					number: this.$route.query.user_number == undefined ? '' : this.$route.query.user_number,
					card_number: '',
					mobile: "",
					name: '',
					type: -1,
					status: -1
				},
				init_data: {
					status_list: [],
					type_list: [],
				},
				is_show_balance_option: false,
				table_data: {
					loading: false,
					list: [],
					page_info: {
						page: 1,
						pageSize: 10,
						total: 130
					}
				},
				dlg_preview: {
					visible: false,
					img_url: ''
				}
			}
		},
		created() {
			document.title = '用户列表';
			this.getList();
		},
		methods: {
			searchList() {
				var _this = this;
				_this.table_data.page_info.page = 1;
				_this.getList();
			},
			getList() {
				var _this = this;
				var params = _this.form_search;
				params.p = _this.table_data.page_info.page;
				params.pageSize = _this.table_data.page_info.pageSize;
				_this.table_data.loading = true;
				var status_list = [{
					id: -1,
					name: '全部'
				}];
				var type_list = [{
					id: -1,
					name: '全部'
				}];
				this.$client.get('/adminapi/user/joinlist', params, function(res, message) {
					_this.table_data.list = res.list;
					_this.table_data.page_info = res.pager;
					_this.init_data.status_list = status_list.concat(res.status_name_list);
					_this.init_data.type_list = type_list.concat(res.type_name_list);
					_this.is_show_balance_option = res.is_show_balance_option;
					_this.table_data.loading = false;
				}, function(res) {
					_this.table_data.loading = false;
				});
			},
			handleSizeChange(val) {
				this.table_data.page_info.pageSize = val;
				this.getList();
			},
			handleCurrentChange(val) {
				this.table_data.page_info.page = val;
				this.getList();
			},
			changeFixed(clientHeight) {
				this.$refs.contentBody.style.minHeight = (clientHeight - 394) + 'px';
			}
		},
		mounted() {
			// 获取浏览器可视区域高度
			this.clientHeight = `${document.documentElement.clientHeight}` //document.body.clientWidth;
			window.onresize = function temp() {
				this.clientHeight = `${document.documentElement.clientHeight}`;
			};
		},
		watch: {
			// 如果 `clientHeight` 发生改变，这个函数就会运行
			clientHeight: function() {
				this.changeFixed(this.clientHeight)
			}
		}
	}
</script>
<style>

</style>
<style scoped>
	.balance-title {
		text-align: center;
		font-size: 18px;
		color: #161616;
	}

	.balance-text {
		font-size: 14px;
		color: #161616;
		padding: 20px;
		text-align: center;
		margin-bottom: 20px;
	}

	.balance-text span {
		font-size: 24px;
	}
</style>
